/**
 * @generated SignedSource<<fea2d740ce5705e2b312a4fcfe696611>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useCellsConditionalFormatting$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly fieldSetId: string | null | undefined;
      readonly fields: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly date?: AGG$Date | null | undefined;
            readonly dateTime?: AGG$DateTime | null | undefined;
            readonly fieldId: string;
            readonly issueType?: {
              readonly issueTypeId: string | null | undefined;
            } | null | undefined;
            readonly number?: number | null | undefined;
            readonly priority?: {
              readonly priorityId: string;
            } | null | undefined;
            readonly project?: {
              readonly projectId: string | null | undefined;
            } | null | undefined;
            readonly selectedComponentsConnection?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly componentId: string;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly selectedLabelsConnection?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly name: string | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly selectedOption?: {
              readonly label: string | null | undefined;
            } | null | undefined;
            readonly selectedSprintsConnection?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly sprintId: string;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly selectedUsersConnection?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly accountId: string;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly selectedValue?: {
              readonly id: string;
            } | null | undefined;
            readonly selectedValues?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly selectedVersionsConnection?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly versionId: string;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly status?: {
              readonly statusId: string;
            };
            readonly text?: string | null | undefined;
            readonly user?: {
              readonly accountId: string;
              readonly id: string;
            } | null | undefined;
            readonly version?: {
              readonly versionId: string;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "useCellsConditionalFormatting";
};
export type useCellsConditionalFormatting$key = {
  readonly " $data"?: useCellsConditionalFormatting$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormatting">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "versionId"
  }
],
v4 = [
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useCellsConditionalFormatting",
  "selections": [
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "fieldSetId"
            },
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fieldId"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "text"
                            }
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "args": (v0/*: any*/),
                              "concreteType": "JiraComponentConnection",
                              "kind": "LinkedField",
                              "name": "selectedComponentsConnection",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraComponentEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "concreteType": "JiraComponent",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "name": "componentId"
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "storageKey": "selectedComponentsConnection(first:1000)"
                            }
                          ],
                          "type": "JiraComponentsField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "args": (v0/*: any*/),
                              "concreteType": "JiraLabelConnection",
                              "kind": "LinkedField",
                              "name": "selectedLabelsConnection",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraLabelEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "concreteType": "JiraLabel",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "name": "name"
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "storageKey": "selectedLabelsConnection(first:1000)"
                            }
                          ],
                          "type": "JiraLabelsField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "user",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v2/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraSingleSelectUserPickerField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraUserConnection",
                              "kind": "LinkedField",
                              "name": "selectedUsersConnection",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraUserEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        (v1/*: any*/)
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ],
                          "type": "JiraMultipleSelectUserPickerField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "date"
                            }
                          ],
                          "type": "JiraDatePickerField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "dateTime"
                            }
                          ],
                          "type": "JiraDateTimePickerField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "number"
                            }
                          ],
                          "type": "JiraNumberField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraPriority",
                              "kind": "LinkedField",
                              "name": "priority",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "priorityId"
                                }
                              ]
                            }
                          ],
                          "type": "JiraPriorityField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraProject",
                              "kind": "LinkedField",
                              "name": "project",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "projectId"
                                }
                              ]
                            }
                          ],
                          "type": "JiraProjectField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraSprintConnection",
                              "kind": "LinkedField",
                              "name": "selectedSprintsConnection",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraSprintEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "concreteType": "JiraSprint",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "name": "sprintId"
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ],
                          "type": "JiraSprintField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraVersion",
                              "kind": "LinkedField",
                              "name": "version",
                              "plural": false,
                              "selections": (v3/*: any*/)
                            }
                          ],
                          "type": "JiraSingleVersionPickerField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "issueTypeId"
                                }
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraStatus",
                              "kind": "LinkedField",
                              "name": "status",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "statusId"
                                }
                              ]
                            }
                          ],
                          "type": "JiraStatusField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "args": (v0/*: any*/),
                              "concreteType": "JiraVersionConnection",
                              "kind": "LinkedField",
                              "name": "selectedVersionsConnection",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraVersionEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "concreteType": "JiraVersion",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": (v3/*: any*/)
                                    }
                                  ]
                                }
                              ],
                              "storageKey": "selectedVersionsConnection(first:1000)"
                            }
                          ],
                          "type": "JiraMultipleVersionPickerField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "selectedValue",
                              "plural": false,
                              "selections": (v4/*: any*/)
                            }
                          ],
                          "type": "JiraSingleSelectField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraSelectableValueConnection",
                              "kind": "LinkedField",
                              "name": "selectedValues",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraSelectableValueEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": (v4/*: any*/)
                                    }
                                  ]
                                }
                              ]
                            }
                          ],
                          "type": "JiraMultipleSelectField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraOption",
                              "kind": "LinkedField",
                              "name": "selectedOption",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": "label",
                                  "kind": "ScalarField",
                                  "name": "value"
                                }
                              ]
                            }
                          ],
                          "type": "JiraRadioSelectField"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};
})();

(node as any).hash = "2151ef0116104b28f71c46bfce531ce1";

export default node;
